module.exports = __webpack_public_path__ + "img/3-lugar.c1693ead.svg";